import { getUserQr } from '@/api/api'
import { useRequest } from 'ahooks'
import React, { useState } from 'react'

const useUserQr = () => {
  const [userQr, setUserQr] = useState<any>('')

  const { run: fetchUserQr, loading: userQrLoading } = useRequest(getUserQr, {
    manual: true,
    onSuccess(data: any) {
      setUserQr(data)
    },
    onError(error: any) {},
  })

  return { fetchUserQr, userQrLoading, userQr }
}

export default useUserQr
